import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const VerifyOTP = React.createContext({});
export let verifyOTPMachine: any;

const MODULE_NAME = 'machines.VerifyOTP';

export const useSMVerifyOTP = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  verifyOTPMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(verifyOTPMachine);

  return {
    verifyOTPMachine,
    verifyOTPState: state,
    verifyOTPSend: send,
  };
};
